// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import Tdg_OrganisationListModel from '../../model/tdg-organisation-list-model';
import Tdg_OrganisationListDTO from '../dto/tdg-organisation-list-dto';
import dtoSchema from '../schemas/tdg-organisation-list-schema';
import ResourceLinkModel from '../../model/resource-link-model';

export default abstract class Tdg_OrganisationListModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<Tdg_OrganisationListDTO>) {
    super();
    if (data) {
      this.id = data.id;
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
      this.creatorId = data.creatorId;
      this.creatorName = data.creatorName ?? undefined;
      this.created = data.created;
      this.modifierId = data.modifierId ?? undefined;
      this.modifierName = data.modifierName ?? undefined;
      this.modified = data.modified ?? undefined;
      this.externalId = data.externalId;
      this.organisationName = data.organisationName ?? undefined;
      this.logoDocumentId = data.logoDocumentId ?? undefined;
      this.membersCount = data.membersCount;
      this.organisationContactSalutation = data.organisationContactSalutation ?? undefined;
      this.organisationContactFirstName = data.organisationContactFirstName ?? undefined;
      this.organisationContactLastName = data.organisationContactLastName ?? undefined;
      this.organisationContactPhoneNumber = data.organisationContactPhoneNumber ?? undefined;
      this.organisationContactEmail = data.organisationContactEmail ?? undefined;
      this.organisationStreet = data.organisationStreet ?? undefined;
      this.organisationHouseNumber = data.organisationHouseNumber ?? undefined;
      this.organisationZIP = data.organisationZIP ?? undefined;
      this.organisationCity = data.organisationCity ?? undefined;
      this.isActive = data.isActive ?? undefined;
      this.acceptConditions = data.acceptConditions;
      this.isSupporter = data.isSupporter ?? undefined;
      this.eventId = data.eventId;
      this.eventName = data.eventName ?? undefined;
      this.eventIdentifier = data.eventIdentifier;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;
  /**
  */
  links?: ResourceLinkModel[];
  /**
  * @type {int64}
  */
  creatorId?: number;
  /**
  */
  creatorName?: string;
  /**
  * @type {date-time}
  */
  created?: string;
  /**
  * @type {int64}
  */
  modifierId?: number;
  /**
  */
  modifierName?: string;
  /**
  * @type {date-time}
  */
  modified?: string;
  /**
  * @type {uuid}
  */
  externalId?: string;
  /**
  */
  organisationName?: string;
  /**
  * @type {int64}
  */
  logoDocumentId?: number;
  /**
  * @type {int32}
  */
  membersCount?: number;
  /**
  * @type {int32}
  */
  organisationContactSalutation?: number;
  /**
  */
  organisationContactFirstName?: string;
  /**
  */
  organisationContactLastName?: string;
  /**
  */
  organisationContactPhoneNumber?: string;
  /**
  */
  organisationContactEmail?: string;
  /**
  */
  organisationStreet?: string;
  /**
  */
  organisationHouseNumber?: string;
  /**
  */
  organisationZIP?: string;
  /**
  */
  organisationCity?: string;
  /**
  */
  isActive?: boolean;
  /**
  */
  acceptConditions?: boolean;
  /**
  */
  isSupporter?: boolean;
  /**
  * @type {int64}
  */
  eventId?: number;
  /**
  */
  eventName?: string;
  /**
  * @type {uuid}
  */
  eventIdentifier?: string;

  static toModel(dto: DeepPartial<Tdg_OrganisationListDTO>): Tdg_OrganisationListModel;
  static toModel(dto: DeepPartial<Tdg_OrganisationListDTO> | undefined | null): Tdg_OrganisationListModel | undefined;
  static toModel(dto: DeepPartial<Tdg_OrganisationListDTO> | undefined | null): Tdg_OrganisationListModel | undefined {
    return dto ? new Tdg_OrganisationListModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<Tdg_OrganisationListModel> | Tdg_OrganisationListModel): Tdg_OrganisationListDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
      links: unwrapped.links,
      creatorId: unwrapped.creatorId,
      creatorName: unwrapped.creatorName,
      created: unwrapped.created,
      modifierId: unwrapped.modifierId,
      modifierName: unwrapped.modifierName,
      modified: unwrapped.modified,
      externalId: unwrapped.externalId,
      organisationName: unwrapped.organisationName,
      logoDocumentId: unwrapped.logoDocumentId,
      membersCount: unwrapped.membersCount,
      organisationContactSalutation: unwrapped.organisationContactSalutation,
      organisationContactFirstName: unwrapped.organisationContactFirstName,
      organisationContactLastName: unwrapped.organisationContactLastName,
      organisationContactPhoneNumber: unwrapped.organisationContactPhoneNumber,
      organisationContactEmail: unwrapped.organisationContactEmail,
      organisationStreet: unwrapped.organisationStreet,
      organisationHouseNumber: unwrapped.organisationHouseNumber,
      organisationZIP: unwrapped.organisationZIP,
      organisationCity: unwrapped.organisationCity,
      isActive: unwrapped.isActive,
      acceptConditions: unwrapped.acceptConditions,
      isSupporter: unwrapped.isSupporter,
      eventId: unwrapped.eventId,
      eventName: unwrapped.eventName,
      eventIdentifier: unwrapped.eventIdentifier,
    } as Tdg_OrganisationListDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for Tdg_OrganisationListModel, can not map to Tdg_OrganisationListDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
